<template>
    <div class="cl-upload">
        <div class="cl-upload-item" v-for="(img, i) in list" :key="i">
            <div class="upload-item-ctx">
                <img :src="img" class="upload-item-img" v-if="type == 'image'" />
                <div class="upload-item-video" v-else-if="type == 'video'">
                    <i class="el-icon-video-play"></i>
                </div>
                <div class="upload-item-btn">
                    <a-icon type="zoom-in" @click.stop="preview(img)" />
                    <a-icon type="delete"  @click.stop="del(i)" />
                </div>
            </div>
        </div>
        <div class="cl-upload-item cl-upload-add" v-show="list.length < max">
            <div class="upload-item-ctx">
                <div class="cl-upload-process" v-if="bs">
                    <el-progress class="cl-process-bar" type="circle" :width="100" :percentage="p"></el-progress>
                </div>
                <template v-else>
                    <div class="add-icon"></div>
                    <input type="file" accept="image/*" @change="handleChange" v-if="type == 'image'">
                    <input type="file" accept="video/mp4" @change="handleChange" v-else-if="type == 'video'">
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {uploadFile, beforeUpload} from "../common/js/upload";
    import {directUploadTencentCloud} from "../common/js/tencent_cloud";

    export default {
        name: "cl-upload",
        props: {
            type: {
                type: String,
                default: 'image'
            },
            max: {
                type: Number,
                default: 1
            },
            //图片上传大小限制
            size: {
                type: Number,
                default: 1024 * 2
            },
            value: [String, Array],
            local: Boolean, //是否上传到本地
            //上传后是否显示图片
            showItem:{
                type:Boolean,
                default:true
            },
            //是否直传
            direct:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                list: [],
                bs: false,
                p: 0
            }
        },
        watch: {
            value() {
                this.setList();
            }
        },
        created() {
            this.setList();
        },
        methods: {
            setList() {
                let value = this.value;
                if(value) {
                    if(Object.prototype.toString.call(value) === '[object Array]') {
                        let max = this.max;
                        this.list = value.slice(0, max);
                    } else {
                        this.list = [value];
                    }
                } else {
                    this.list = [];
                }
            },
            triggerInput() {
                let val = this.list;
                this.$emit("input", val.length == 1 ? val[0] : val);
            },
            handleChange(e) {
                let input = e.currentTarget;
                let files = [...input.files];
                let flag = true;
                let type = this.type;
                if(type == 'image') {
                    for(let i = 0, l = files.length; i < l; i++) {
                        let file = files[i];
                        if(!beforeUpload(file, this.size)) {
                            flag = false;
                            break;
                        }
                    }
                }
                if(flag) {
                    let temp = []
                    let tempList = this.list
                    if(!this.direct && type == 'image'){
                       files.forEach(file => {
                            temp.push(uploadFile({file}));
                        });
                    } else {
                        this.bs = true;
                        let prs = [];
                        files.forEach((file, i) => {
                            prs.push(0);
                            temp.push(
                                directUploadTencentCloud(file, progress => {
                                    prs[i] = progress.percent;
                                    this.setProgress(prs);
                                }).then(data => {
                                    let path = "https://" + data.Location;
                                    return path
                                })
                            );
                        });
                    }
                    Promise.all(temp).then(res => {
                        input.value = '';
                        this.list = this.list.concat(res);
                        this.triggerInput();
                        if(!this.showItem){
                            //如果不显示就不对list做任何操作
                            this.list = tempList;
                        }
                        this.bs = false;
                    }).catch(() => {
                        this.bs = false;
                        input.value = '';
                    })
                } else {
                    input.value = '';
                }
            },
            setProgress(prs) {
                let l = prs.length;
                let total = prs.reduce((acc, val) => acc + val);
                this.p = Math.round(total / l * 100);
            },
            preview(img) {
                this.$store.dispatch("showImgList", [{ url: img }]);
            },
            del(i) {
                this.list.splice(i, 1);
                this.triggerInput();
            }
        }
    }
</script>

<style lang="less">
    .cl-upload {
        margin: -6px;
        font-size: 0;
    }
    .cl-upload-item {
        display: inline-block;
        padding: 6px;
        width: 33.33333333%;
    }
    .upload-item-ctx {
        --border-color: #DCDFE6;
        --border: 1px solid var(--border-color);

        position: relative;
        padding-bottom: 100%;
        width: 100%;
        height: 0;
        border: var(--border);
        cursor: pointer;
        &:hover {
            .upload-item-btn {
                display: flex;
            }
        }
        .add-icon,
        input {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
        input {
            opacity: 0;
            cursor: pointer;
        }
        .add-icon {
            margin: auto;
            width: 50px;
            height: 50px;
        }
    }
    .upload-item-btn,
    .upload-item-video,
    .upload-item-img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
    .upload-item-video {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #000;
        font-size: 30px;
        color: #fff;
    }
    .upload-item-btn {
        display: none;
        align-items: center;
        justify-content: space-around;
        background-color: rgba(0,0,0,0.5);
        font-size: 20px;
        color: #ffffff;
    }
    .cl-upload-process {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;
        z-index: 10002;
    }
</style>
